import React, { Fragment } from "react";
import { Box, InputLabel, Tooltip, IconButton, useTheme } from "@mui/material";
import { useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

import axios from "../../utils/axios.tsx";
import { fetchSpreadsheets } from "../../store/conversation.tsx";

interface SpreadsheetRowProps {
  name: string;
  fileId: string;
  index: number;
  addedBy: string;
}

const SpreadsheetRow: React.FC<SpreadsheetRowProps> = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const handleDeleteSpreadsheet = async (fileId: string) => {
    await axios
      .post("/v1/google-sheets/delete/", JSON.stringify({ file_id: fileId }))
      .then((_) => {
        dispatch(fetchSpreadsheets() as any);
      });
  };

  return (
    <Fragment>
      <Box mt={2} mb={2}>
        <InputLabel>
          {props.index}: {props.name} - Added By: {props.addedBy}
        </InputLabel>
        <Tooltip
          title={i18n._(
            msg({
              context: "Button title to delete a spreadsheet",
              message: "Delete",
            }),
          )}
          arrow
        >
          <IconButton
            onClick={() => handleDeleteSpreadsheet(props.fileId)}
            size="small"
            aria-label="delete-spreadsheet"
          >
            <DeleteIcon
              fontSize="small"
              style={{ color: theme.palette.primary.main }}
            />
          </IconButton>
        </Tooltip>
      </Box>
    </Fragment>
  );
};

export default SpreadsheetRow;
